import { lazy } from 'react';

export default lazy(() =>
  import(/* webpackChunkName: 'analytics_explore' */ './ExplorePage'),
);
